export enum ActionStates {
  COMPLETE_BOX = 0,
  SCAN_SHELF_OR_CART = 1,
  SET_CART = 2,
  SCAN_SINGLE_ARTICLE = 3,
}